module.exports = __webpack_public_path__ + "img/safecrypt.799179cf.webp";